export { Accordion, Accordions } from "fumadocs-ui/components/accordion";
